import React from 'react';
import { connect } from 'react-redux';

import CopyDialog from './CopyDialog';

import { getForms, resetSelectedForm } from '../../../store/forms/actions';


function Manager (props) {
    const { form } = props;
        
    const handleCopy = () => {
        const { getForms, resetSelectedForm } = props;
        getForms();
        resetSelectedForm();
    };

    return (
        <CopyDialog
            handleCopy={handleCopy}
            form={form}
        />
    );
}

const mapStateToProps = state => ({
    form: state.forms.selected
});

const mapDispatchToProps = dispatch => ({
    getForms: () => dispatch(getForms()),
    resetSelectedForm: () => dispatch(resetSelectedForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
